<template>
  <div class="container">
    <case-build-assistant-container
      :id="caseId"
      @added="id => onCaseAdded(id)" @close="onCaseClosed"
      @onSaveStart="onSaveStart"
      @onSaveEnd="onSaveEnd"
    />
  </div>
</template>

<script>
import CaseBuildAssistantContainer from '../containers/CaseBuildAssistant';

export default {
  name: 'editor',
  components: {
    CaseBuildAssistantContainer,
  },
  data() {
    return {
      state: {
        savingCase: false,
      }
    }
  },
  computed: {
    caseId() {
      return this.$route.params.id;
    },
  },
  methods: {
    onCaseAdded(caseId) {
      this.$router.replace({ params: { id: caseId } });
    },
    onCaseClosed() {
      if (this.fromPath !== '/cases') {
        this.$router.push({ name: 'cases' });
      } else {
        this.$router.go(-1);
      }
    },
    onSaveStart() {
      this.state.savingCase = true;
    },
    onSaveEnd() {
      this.state.savingCase = false;
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.fromPath = from.fullPath;
    });
  },
  beforeRouteLeave(to, from, next) {
    // Give a chance to all components
    // to save their changes before exiting
    // the route
    this.$eventHub.$emit('CASE::FLUSH_PENDING_CHANGES');
    this.$nextTick(() => {
      if (this.state.savingCase) {
        const unwatch = this.$watch('state.savingCase', (savingCase) => {
          unwatch();
          if (!savingCase) {
            next();
          }
        });
      } else {
        next();
      }
    });
  }
};
</script>

<style scoped>
.container {
  height: 100%;
}
</style>
